'use client';

import { memo } from 'react';
import { StickyNavbar } from './components/StickyNavbar';
const NavbarInternal = () => {
  return <StickyNavbar data-sentry-element="StickyNavbar" data-sentry-component="NavbarInternal" data-sentry-source-file="Navbar.tsx" />;
};
export const Navbar = memo(NavbarInternal);